
<template>
  <div class="max-w-4xl mx-auto p-6">
    <div v-if="campaign">
      <h1 class="text-3xl font-bold text-green-700 mb-4">{{ campaign.title }}</h1>
      <p class="text-gray-600 mb-2">
        {{ formatDate(campaign.startDate) }} - {{ formatDate(campaign.endDate) }}
      </p>
      <img
        v-if="campaign.banner"
        :src="campaign.banner"
        alt="Banner"
        class="w-full rounded-xl mb-4"
      />
      <p class="text-gray-800 whitespace-pre-line">{{ campaign.details }}</p>

      
     <div v-if="campaign.submission === 'open' && isLoggedIn" class="mt-6">
  <RouterLink
    :to="`/submit-campaign/${campaign.slug}`"
    class="inline-block bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
  >
    Submit Your Entry
  </RouterLink>
</div>

    </div>

    
    <div v-else class="text-center py-20 text-gray-500">
      Loading campaign...
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { db } from '@/firebase'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useHead } from '@vueuse/head'

const route = useRoute()
const slug = route.params.slug
const campaign = ref(null)
const isLoggedIn = ref(false) // ✅ Initialize as a ref
const pageUrl = window.location.origin + route.fullPath

// ✅ Check Firebase Auth state
onMounted(() => {
  const auth = getAuth()
  onAuthStateChanged(auth, (user) => {
    isLoggedIn.value = !!user
  })

  fetchCampaignBySlug()
})

const formatDate = (date) => {
  if (!date) return ''
  const d = date.toDate ? date.toDate() : new Date(date)
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

const fetchCampaignBySlug = async () => {
  try {
    const q = query(collection(db, 'campaign'), where('slug', '==', slug))
    const snapshot = await getDocs(q)

    if (!snapshot.empty) {
      campaign.value = { id: snapshot.docs[0].id, ...snapshot.docs[0].data() }

      useHead({
        title: campaign.value.title,
        meta: [
          { name: 'description', content: campaign.value.details?.slice(0, 150) || '' },
          { property: 'og:title', content: campaign.value.title },
          { property: 'og:description', content: campaign.value.details?.slice(0, 150) || '' },
          { property: 'og:image', content: campaign.value.banner || '' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: pageUrl }, // ✅ Add this line

        ]
      })
    } else {
      alert('Campaign not found')
    }
  } catch (err) {
    console.error('Failed to fetch campaign:', err)
    alert('Something went wrong.')
  }
}
</script>
